import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import GridMap from '../components/GridMap';
import alcoholByState from '../data/alcoholByState';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "grid-map"
    }}>{`Grid Map`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/GridMap"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    {
      /* https://worldpopulationreview.com/state-rankings/alcohol-consumption-by-state */
    }
    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#FFF897\">\n  <GridMap\n    width={360}\n    height={270}\n    data={alcoholByState}\n    encoding={{\n      key: { field: \'State\' },\n      fill: {\n        type: \'quantitative\',\n        field: \'alcoholConsumptionGallons\',\n        scale: {\n          zero: false,\n          interpolate: \'hsl\',\n          range: [\'#FAE96F\', \'#C96E12\'],\n        },\n      },\n    }}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      GridMap,
      alcoholByState,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#FFF897" mdxType="Frame">
    <GridMap width={360} height={270} data={alcoholByState} encoding={{
          key: {
            field: 'State'
          },
          fill: {
            type: 'quantitative',
            field: 'alcoholConsumptionGallons',
            scale: {
              zero: false,
              interpolate: 'hsl',
              range: ['#FAE96F', '#C96E12']
            }
          }
        }} mdxType="GridMap" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      